import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HtmlTemplate } from '../dto/templates/html-template';

@Injectable()
export class EmailPreviewService {
  readonly apiPath = 'email-preview/';
  constructor(
    private http: HttpClient,
  ) { }

  sendEmailPreview(template: HtmlTemplate): Observable<Object> {
    return this.http.post(this.apiPath, template);
  }
}
